/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';

import Header from './components/layout/Header';
import { APPBAR_HEIGHT } from './util/consts';
import AddToCartProvider from './features/cart/components/useAddToCartModal';
import DrawdownProvider from './features/drawdown/v1/useDrawdownRequest';
import { PickUpStoreModalProvider } from './features/cart/components/PickUpStoreModal';
import AtomicProvider from './services/atomic/AtomicProvider';
import { AccountSwitcherProvider } from './features/azure-b2c/components/AccountSwitcherProvider';
import { PageLayout } from './AppPage';
import { BackgroundProvider } from './contexts/BackgroundContext';

export const AppProviders: React.FC<{
  children: React.ReactNode;
  ready: boolean;
  fallback: React.ReactNode;
}> = (props) => {
  if (props.ready) {
    return (
      <AccountSwitcherProvider>
        <AtomicProvider>
          <PickUpStoreModalProvider>
            <AddToCartProvider>
              <DrawdownProvider>
                <BackgroundProvider>
                  <Header appbarHeight={APPBAR_HEIGHT} />
                  <PageLayout>{props.children}</PageLayout>
                </BackgroundProvider>
              </DrawdownProvider>
            </AddToCartProvider>
          </PickUpStoreModalProvider>
        </AtomicProvider>
      </AccountSwitcherProvider>
    );
  } else {
    return props.fallback;
  }
};

export default AppProviders;
